import request from '@/utils/request'
import { getCommunityId } from '@/utils/communityId'

export function generateAppKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/openApi.generateAppKey',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateOpenApiApp(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/openApi.updateOpenApiApp',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteOpenApiApp(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/openApi.deleteOpenApiApp',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listOpenApiApps(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/openApi.listOpenApiApps',
      method: 'post',
      data: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        apps: res.data || [],
        total: res.total || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}